export default "__VITE_ASSET__BBFLHbDB__"